import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { NotificationHandlerService } from '../notifications/notification-handler.service';

export const LOADING_BAR = 'loadingbar';
export const WORKING_BAR = 'workingbar';

@Injectable()
export class LoadingService {

    private itemLoadingCount: number;
    public isLoading = new BehaviorSubject<boolean>(false);

    constructor(private _notificationService: NotificationHandlerService) {
        this.itemLoadingCount = 0;
    }

    public itemLoading(): void {
        this.itemLoadingCount += 1;
        if (this.itemLoadingCount > 0) {
            this._notificationService.logConsoleInfo('Loading service broadcast: true');
            this.isLoading.next(true);
        }
    }

    public itemLoaded(): void {
        this.itemLoadingCount -= 1;
        if (this.itemLoadingCount < 1) {
            this._notificationService.logConsoleInfo('Loading service broadcast: false');
            this.isLoading.next(false);
            this.itemLoadingCount = 0;
        }
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/loading/loading.service.ts